import { useQuery } from '@tanstack/react-query';
import { useAppBridge } from '@shopify/app-bridge-react';
import { makeApi } from '../api';
import type { DashboardResponse } from '../types';

// R10: `WORKER_ORIGIN = ''` means "same-origin" — we issue `fetch('/api/shopify/*')`
// relative to wherever the SPA is hosted (e.g. `shopify-dev.unifd.app`).
//
// This is correct ONLY because Task 25 of the merchant-app workstream wires a
// Cloudflare Worker route binding `shopify-*.unifd.app/api/shopify/*` → the
// `unifd-*` worker (which mounts `shopifyEmbeddedApp` via sub-issue #346). Until
// both of those land, `/api/shopify/*` requests will hit CF Pages' SPA fallback
// and return `index.html` instead of JSON — see PR description.
const WORKER_ORIGIN = '';

export function useDashboard() {
  const app = useAppBridge();
  return useQuery<DashboardResponse>({
    queryKey: ['shopify-dashboard'],
    queryFn: () => makeApi(app, WORKER_ORIGIN).getDashboard(),
    refetchInterval: 30_000,
  });
}
